import { objectService } from '@/modules/common/api';
import { apiClient } from '../../../provider';
import { prepareObject } from '../../../provider/utils';
import planScheme from './plan.graphql';

export default {
  ...objectService,
  fetchPlanSchemaId() {
    return apiClient
      .query({
        query: planScheme.fetchPlanSchemaId
      })
      .then(r => r.data.schemata[0]?.id || '');
  },
  async fetch(id) {
    const res = await apiClient.query({
      query: planScheme.fetch,
      variables: {
        id
      },
      fetchPolicy: 'no-cache'
    });
    return prepareObject(res.data.object);
  },
  create({ name, description, enabled, schemaId }) {
    return apiClient
      .mutate({
        mutation: planScheme.create,
        variables: {
          input: {
            object: {
              name,
              description,
              enabled,
              schemaId
            }
          }
        }
      })
      .then(r => prepareObject(r.data?.createObject?.object));
  },
  update(id, { name, description }) {
    return apiClient.mutate({
      mutation: planScheme.update,
      variables: {
        id,
        name,
        description
      }
    });
  }
};
